import axios from 'axios'

export default {
    data() {
        return {
            token: null,
            headers: {},
        }
    },
    methods: {
        setTokenOnly() {
           axios.get(this.$store.state.astilleroURL + '/services/session/token')
            .then(res => {
                this.token = res.data
                console.log('Getting session token', res.data)
            })
            .catch(error => console.log('Error al cargar el token: ' + error))
        },
        setCookieToken() {
            return axios.post(this.$store.state.astilleroURL + '/api/system/connect', {
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then(res => {
                this.headers = {
                    'Content-Type': 'application/json',
                    'X-Cookie': this.$store.state.user.session_name + '=' + this.$store.state.user.sessid,
                    'X-CSRF-Token': this.$store.state.token
                    //'X-CSRF-Token': this.token
                }
                console.log('Cookie token set', res.data)
            })
            .catch(error => console.log(error))
        },
        createNode(data) {
            return axios.post(this.$store.state.astilleroURL + '/api/node', data, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Cookie': this.$store.state.user.session_name + '=' + this.$store.state.user.sessid,
                    'X-CSRF-Token': this.$store.state.token
                },
                withCredentials: true
            })
			.then(res => (res))
			.catch(error => console.log(error))
        },
        getNode(nid) {
            return axios.get(this.$store.state.astilleroURL + '/api/node/' + nid, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Cookie': this.$store.state.user.session_name + '=' + this.$store.state.user.sessid,
                    'X-CSRF-Token': this.$store.state.token
                }
            })
			.then(res => (res))
			.catch(error => console.log(error))
        },
        deleteNode(nid) {
            return axios.delete(this.$store.state.astilleroURL + '/api/node/' + nid, {
                headers: this.headers,
                withCredentials: true
            })
			.then(res => (res))
			.catch(error => console.log(error))
        },
        getUser(uid) {
            return axios.get(this.$store.state.astilleroURL + '/api/user/' + uid)
			.then(res => (res))
			.catch(error => console.log(error))
        },
        sendOrder(data) {
            return axios.post(this.$store.state.astilleroURL + '/api/pos-actions/create-order', data, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Cookie': this.$store.state.user.session_name + '=' + this.$store.state.user.sessid,
                    'X-CSRF-Token': this.$store.state.token
                },
                withCredentials: true
            })
			.then(res => (res))
			.catch(error => console.log(error))
        },
        getConfigVariable(variable_name) {
            return axios.post(this.$store.state.astilleroURL + '/api/system/get_variable', {
                name: variable_name
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Cookie': this.$store.state.user.session_name + '=' + this.$store.state.user.sessid,
                    'X-CSRF-Token': this.$store.state.token
                }
            })
			.then(res => (res))
			.catch(error => console.log(error))
        },
        getOrders() {
            return axios.get(this.$store.state.astilleroURL + '/api/pedidos', {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Cookie': this.$store.state.user.session_name + '=' + this.$store.state.user.sessid,
                    'X-CSRF-Token': this.$store.state.token
                }
            })
			.then(res => (res))
			.catch(error => console.log(error))
        },
        updateOrderStatus(data) {
            return axios.post(this.$store.state.astilleroURL + '/api/pos-actions/update-order-status', data, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Cookie': this.$store.state.user.session_name + '=' + this.$store.state.user.sessid,
                    'X-CSRF-Token': this.$store.state.token
                },
                withCredentials: true
            })
			.then(res => (res))
			.catch(error => console.log(error))
        },
    }
}